import { render } from "./long-insure-worker.vue?vue&type=template&id=222839b4&scoped=true&ts=true"
import script from "./long-insure-worker.vue?vue&type=script&lang=ts"
export * from "./long-insure-worker.vue?vue&type=script&lang=ts"

import "./long-insure-worker.vue?vue&type=style&index=0&id=222839b4&lang=stylus&scoped=true"

import exportComponent from "D:\\Repository\\Zidan\\pc-customer-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-222839b4"]])

export default __exports__